export const jqHomeFeaturedSecondaryCard = () => {
	const fixedScroll = document.querySelectorAll(".fixed-width-sm-scroll");

	const lastHPos = 0;
	const homeSecondary = document.querySelectorAll(".home-featured-secondary");
	const dots = document.querySelectorAll(".home-featured-secondary-dot");
	const container = document.querySelectorAll(".home-featured-secondary-container");
	const cards = document.querySelectorAll(".home-featured-secondary");

	const scrollDotsDetector = () => {
		var scrollFlatWidth = [...homeSecondary].reduce((acc, el) => acc + el.offsetWidth, 0);
		if (scrollFlatWidth <= window.innerWidth) {
			[...document.querySelectorAll(".home-featured-secondary-dots")].forEach((el) =>
				el.classList.add("hide")
			);
		} else {
			[...document.querySelectorAll(".home-featured-secondary-dots")].forEach((el) =>
				el.classList.remove("hide")
			);
		}
	};

	const alignmentThumb = () => {
		var thumbFlag = false;
		[...homeSecondary]
			.filter(
				(el) =>
					el.classList.contains("home-featured-secondary-single-card") &&
					el.querySelectorAll(".content-card-img").length !== 0
			)
			.forEach(() => {
				thumbFlag = true;
			});

		if (thumbFlag) {
			[...homeSecondary].forEach((el) => {
				[...el.querySelectorAll(".content-card-preview-container")].forEach((card) => {
					card.classList.add("content-card-preview-thumb-alignment");
				});
			});
		}
	};
	const selectedDot = (index) => {
		for (let sibling of dots) {
			sibling.classList.remove("home-featured-secondary-dot-current");
		}
		dots[index].classList.add("home-featured-secondary-dot-current");
	};

	scrollDotsDetector();
	alignmentThumb();
	window.addEventListener("resize", function () {
		scrollDotsDetector();
	});

	if (container) {
		let timer = null;
		[...container].forEach(function (element) {
			element.addEventListener("scroll", function () {
				if (timer !== null) {
					clearTimeout(timer);
				}
				timer = setTimeout(function () {
					const middle = fixedScroll.offsetWidth / 2;
					[...cards].forEach((card, i) => {
						const cardPos = card.getBoundingClientRect();
						if (middle < cardPos.x + card.offsetWidth && cardPos.x <= middle) {
							selectedDot(i);
						}
					});
				}, 200);
			});
		});
	}
	[...fixedScroll].forEach(function (element) {
		element.addEventListener("scroll", function () {
			var currHPos = element.scrollLeft;
			var cards = element.querySelectorAll(".home-featured-secondary");
			var selectedCard = 0;
			var cardsWidth = element.clientWidth;
			var currentCard = [];
			var leftOfCard = 0;
			var rightOfCard = 0;

			[...cards].forEach((card, i) => {
				leftOfCard = card.getBoundingClientRect().left;
				rightOfCard = leftOfCard + (card.offsetWidth - 48); // 48 is used to subtract out padding and margin.
				if (0 <= leftOfCard && rightOfCard <= cardsWidth) {
					currentCard.push(i);
				}
			});
			if (lastHPos < currHPos) {
				selectedCard = currentCard[currentCard.length - 1];
			}
			const parentDots = element.parentNode.querySelectorAll(".home-featured-secondary-dot");

			if (parentDots[selectedCard]) {
				for (let sibling of parentDots) {
					sibling.classList.remove("home-featured-secondary-dot-current");
				}
				parentDots[selectedCard].classList.add("home-featured-secondary-dot-current");
			}
		});
	});
};
